import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=3fa33e33&scoped=true"
import script from "./PhoneLogin.vue?vue&type=script&lang=js"
export * from "./PhoneLogin.vue?vue&type=script&lang=js"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=3fa33e33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa33e33",
  null
  
)

export default component.exports